import { GenericModel } from "../../generic.model";
import { StationModel } from "./station/station.model";
import { makeModel } from "../../../service/utils/utils.service";


export class DataListModel extends GenericModel {
    public stationArray: StationModel[];

    get station(): StationModel {
        return this.stationArray[0];
    }

    protected fromJson(json?: any): boolean {
        this.stationArray = makeModel(json.stationArray, StationModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.stationArray !== null && this.stationArray.length > 0;
    }
}